import { render, staticRenderFns } from "./RecordingsSection.vue?vue&type=template&id=c8cd664c&scoped=true&"
import script from "./RecordingsSection.vue?vue&type=script&lang=js&"
export * from "./RecordingsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cd664c",
  null
  
)

export default component.exports